import { EntityId, createSelector } from '@reduxjs/toolkit';
import { REDUCER_PATH } from '../lib/const';
import { FavoritesReducerStateShape } from './slice';

export const isFavoriteSelector = createSelector(
  [(state: FavoritesReducerStateShape) => state[REDUCER_PATH], (_, userId: EntityId) => userId],
  (state, userId) => state.includes(userId),
);
